export default "__VITE_ASSET__C48D$HDf__"